import * as React from "react";
import { Clock, HeartPulse, MapPin, ArrowLeft, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function NursingCaregiverAshkelonHero() {
  const features = [{
    text: "הגעה מהירה תוך 5 שעות",
    icon: Clock
  }, {
    text: "צוות סיעודי מוסמך ומנוסה",
    icon: ShieldCheck
  }, {
    text: "זמינות מלאה 24/7",
    icon: HeartPulse
  }];
  return <section id="מטפל-סיעודי-באשקלון-פתרון-מיידי" className="bg-background relative overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3">
        <div className="w-96 h-96 bg-primary/5 rounded-lg blur-3xl"></div>
      </div>
      <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3">
        <div className="w-[30rem] h-[30rem] bg-secondary/5 rounded-lg blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col items-start text-right">
            <Badge variant="secondary" className="mb-6 text-sm px-3 py-1">
              <MapPin className="w-4 h-4 ml-2 text-secondary" />
              שירות פעיל באשקלון והסביבה
            </Badge>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground font-default leading-tight mb-6">
              מטפל סיעודי באשקלון <br className="hidden md:block" />
              <span className="text-primary">תוך 5 שעות</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl">
              אנו מבינים שברגעי משבר, זמן הוא קריטי. הצוות המקצועי שלנו זמין לקריאה מיידית כדי להעניק ליקיריכם את הטיפול המסור והטוב ביותר, עם התאמה אישית לצרכים הרפואיים והרגשיים.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10 w-full sm:w-auto">
              <Button asChild size="lg" className="text-base h-12 px-8">
                <Link to="/NursingCareNowPage">
                  מטפל סיעודי בבית
                  <ArrowLeft className="w-5 h-5 mr-2" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-base h-12 px-8">
                <Link to="/ServicesCitiesArticlesPage">
                  השגחה בבית חולים
                </Link>
              </Button>
            </div>

            <div className="flex flex-col gap-3">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={i} data-index={i} className="flex items-center text-foreground">
                    <div className="bg-accent/50 p-2 rounded-md ml-3">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                    <span className="font-medium">{feature.text}</span>
                  </div>;
            })}
            </div>

            <div className="mt-8 pt-6 border-t border-border w-full max-w-md">
              <Link to="/CitySpecificSEOPagesForNursingCareProviderPage" className="inline-flex items-center text-primary hover:text-primary/80 font-medium transition-colors">
                לכל שירותי הסיעוד באשקלון
                <ArrowLeft className="w-4 h-4 mr-2" />
              </Link>
            </div>
          </div>

          {}
          <div className="relative lg:mr-8 mt-10 lg:mt-0">
            <div className="relative rounded-lg overflow-hidden shadow-2xl border border-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashkelon_nursing_care_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashkelon_nursing_care_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashkelon_nursing_care_hero.png-wvc-sizes" alt="מטפל סיעודי מעניק טיפול מסור לקשיש באשקלון" className="w-full h-[400px] lg:h-[600px] object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent"></div>
            </div>

            {}
            <div className="absolute -bottom-6 -right-6 md:-left-6 md:right-auto bg-card p-6 rounded-lg shadow-xl border border-border max-w-[240px]">
              <div className="flex items-center gap-4 mb-2">
                <div className="bg-secondary/20 p-3 rounded-md">
                  <Clock className="w-6 h-6 text-secondary" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground font-medium">זמן הגעה ממוצע</p>
                  <p className="text-xl font-bold text-foreground font-default">עד 5 שעות</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}